module.exports = __webpack_public_path__ + "img/left.619d0e2c.png";